<template>
  <div class="reservation-controls">
    <div class="row">
      <div :class="['columns', shrink ? 'small-12' : 'small-3 padding-R']">
        <a :class="['button cta small block', shrink ? 'xsmall' : '']" href="javascript:;" @click="initMoveToPool">MOVE TO POOL</a>
      </div>
      <div :class="['columns', shrink ? 'small-12' : 'small-3 padding-R']">
        <a :class="['button cta small block error', shrink ? 'xsmall' : '']" @click="removeFromPool">REMOVE FROM POOL</a>
      </div>
      <div :class="['columns', shrink ? 'small-12' : 'small-3 padding-L padding-R']">
        <a :class="['button cta block', shrink ? 'xsmall' : 'small', hasRSVPControl ? 'success' : 'secondary disabled']" href="javascript:;" @click="markAsComplete">MARK AS COMPLETE</a>
      </div>
      <div :class="['columns', shrink ? 'small-12' : 'small-3 padding-L']">
        <a :class="['button cta warning block', shrink ? 'xsmall' : 'small']" href="javascript:;" @click="autoDispatch">AUTO DISPATCH</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reservation-controls',
  props: [ 'shrink' ],
  data () {
    return {
      rsvpQueue: [],
      errorQueue: [],
      successQueue: []
    }
  },
  computed: {
    hasRSVPControl () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl') }
  },
  methods: {
    initMoveToPool () {
      this.errorQueue = []
      this.successQueue = []
      this.rsvpQueue = []
      this.rsvpQueue = [...this.$store.state.dispatch.checkedReservations]

      if (!this.rsvpQueue.length) {
        this.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Select atleast 1 reservation/package.'
        })
        return
      }

      if (!this.isStatusValid(this.rsvpQueue)) {
        this.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only move Upcoming, Requires Dispatch and Ready to Go reservations/packages to the pool.'
        })
        return
      }

      this.$store.commit('dispatch/showActionModal', `Moving ${this.rsvpQueue.length > 1 ? 'items' : 'item'} to pool...`)
      this.moveToPool()
    },
    moveToPool () {
      let self = this
      // let rsvps = self.$store.state.dispatch.checkedReservations
      // if (!self.isValid('Please select only 1 reservation/package to move to the pool.')) {
      //   return
      // }

      // if (!self.isStatusValid(rsvps)) {
      //   self.$store.commit('dispatch/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only move Upcoming, Requires Dispatch and Ready to Go reservations/packages to the pool.'
      //   })
      //   return
      // }

      let rsvp = this.rsvpQueue[0]
      let url = '/admin/rsvp/'
      if (rsvp.isPackage) {
        url = '/admin/package/'
      }
      // self.$store.commit('dispatch/showActionModal', `Moving ${(rsvp.isPackage ? ' package ' : ' reservation ')} to pool...`)

      self.$sdk.post(url + rsvp.id + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) self.errorQueue.push(rsvp)
        else self.successQueue.push(rsvp)

        self.rsvpQueue.shift()
        if (self.rsvpQueue.length) {
          self.moveToPool()
        } else {
          if (!self.successQueue.length && self.errorQueue.length) {
            self.$store.commit('dispatch/completeActionModal', {
              success: false,
              message: 'Something went wrong. Try again later.'
            })
          } else {
            self.$store.commit('dispatch/clearCheckedRsvps')
            let success = []
            let error = []
            self.successQueue.forEach(item => {
              success.push(item.isPackage ? `PKG${item.id}` : `RSVP${item.id}`)
            })
            self.errorQueue.forEach(item => {
              error.push(item.isPackage ? `PKG${item.id}` : `RSVP${item.id}`)
            })
            let msg = `Successfully moved ${success.join(', ')} to pool.`
            if (error.length) {
              msg += `<br/>The following items failed to move to pool: ${error.join(', ')}`
            }
            self.$store.commit('dispatch/completeActionModal', {
              success: true,
              message: msg
            })
          }
        }

        // if (r.error) {
        //   self.$store.commit('dispatch/completeActionModal', {
        //     success: false,
        //     message: 'Something went wrong. Try again later.'
        //   })
        // } else {
        //   self.$store.commit('dispatch/clearCheckedRsvps')
        //   self.$store.commit('dispatch/completeActionModal', {
        //     success: true,
        //     message: 'Successfully moved ' +
        //       (rsvp.isPackage ? ' package ' : ' reservation ') +
        //       rsvp.id + ' to pool.'
        //   })
        // }
        // setTimeout ( () => {
        //   self.$store.commit('dispatch/closeActionModal')
        // }, 1000)
      })
    },
    removeFromPool () {
      let self = this
      let rsvps = self.$store.state.dispatch.checkedReservations
      if (rsvps.length !== 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select only 1 reservation/package to remove from the pool'
        })
        return
      }

      if (['upcoming', 'requires-dispatch'].indexOf(rsvps[0].status) === -1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only remove Upcoming and Requires Dispatch reservations/packages from the pool.'
        })
        return
      }

      let rsvp = rsvps[0]
      let url = '/admin/rsvp/'
      let type = 'reservation'
      if (rsvp.isPackage) {
        url = '/admin/package/'
        type = 'package'
      }

      self.$store.commit('dispatch/showActionModal', 'Removing ' + type + ' from pool...')
      self.$sdk.delete(url + rsvp.id + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('dispatch/clearCheckedRsvps')
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully removed ' + type + ' ' + rsvp.id + ' from pool.'
          })
        }

        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 1000)
      })
    },
    markAsComplete () {
      let self = this
      if (!self.hasRSVPControl) return

      let rsvps = self.$store.state.dispatch.checkedReservations
      if (!self.isValid('Please select only 1 reservation/package to mark as complete.')) {
        return
      }

      if (!self.canMarkAsComplete(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You cannot mark as complete Cancelled or Completed reservations/packages.'
        })
        return
      }

      let rsvp = rsvps[0]

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: rsvp.id,
        isPackage: rsvp.isPackage,
        forComplete: true
      })
      return
    },
    autoDispatch () {
      let self = this
      let rsvps = self.$store.state.dispatch.checkedReservations

      if (!self.isValid('Please select only 1 reservation/package to auto dispatch.')) {
        return
      }

      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only auto-dispatch Upcoming, Requires Dispatch and Ready to Go reservations/packages.'
        })
        return
      }

      let rsvp = rsvps[0]

      // let url = '/admin/rsvp/'
      let url = '/reservation/'
      if (rsvp.isPackage) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Invalid Action',
          message: 'Auto-dispatching a package is not allowed.'
        })
        return
      }
      self.$store.commit('dispatch/showActionModal',
        'Auto-dispatching' +  (rsvp.isPackage ? ' package' : ' reservation') + '...')

      self.$sdk.post(url + rsvp.id + '/autodispatch', {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log(r)
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('dispatch/removeRsvpInTable', rsvp)
          self.$store.commit('dispatch/clearCheckedRsvps')
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully auto-dispatched ' +
                     (rsvp.isPackage ? ' package ' : ' reservation ') +
                     rsvp.id + '.'
          })
        }

        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 1000)
      }, '2.0')
    },
    isValid (message) {
      let self = this
      let rsvps = self.$store.state.dispatch.checkedReservations
      if (rsvps.length !== 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: message
        })
        return false
      }
      return true
    },
    isStatusValid (items) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.status === 'complete' ||
            item.status === 'completed' ||
            item.status === 'canceled' ||
            item.status === 'onboard' ||
            item.status === 'dispatched') {
          return false
        }
      }
      return true
    },
    canMarkAsComplete (items) {for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.status === 'complete' ||
            item.status === 'completed' ||
            item.status === 'canceled') {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.reservation-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  border-top: 1px solid rgba(0,0,0,0.2);
  border-right: 1px solid rgba(0,0,0,0.3);
  background-color: #fff;
}
.padding-R { padding-right: 5px; }
.padding-L { padding-left: 5px; }

.cta.xsmall{ margin-bottom: 5px; }

@media only screen and (max-width: 430px) {
  .small-3 {
    width: 50%;
    a {
      font-size: 11px;
    }
    &.padding-L,
    &.padding-R {
      padding: 2px 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/ReservationControls.vue